// extracted by mini-css-extract-plugin
export default {"viewButton":"AIReview_viewButton__zRlui"};